export const TRIED_RATINGS = [
  { value: 'hot', label: '🔥 Hot!', color: 'from-red-500 to-orange-500' },
  { value: 'good', label: '👍 Good', color: 'from-green-500 to-emerald-500' },
  { value: 'meh', label: '😬 Meh', color: 'from-yellow-500 to-amber-500' },
  { value: 'nope', label: '❌ Nope', color: 'from-zinc-500 to-zinc-600' },
] as const;

export const RATING_OPTIONS = [
  { value: '🔥 Must Try', label: '🔥 Must Try' },
  { value: '👍 Good', label: '👍 Good' },
  { value: '🤔 Maybe', label: '🤔 Maybe' },
  { value: '⏭️ Skip', label: '⏭️ Skip' },
] as const;

export type TriedRatingValue = 'hot' | 'good' | 'meh' | 'nope';
export type ReviewRatingValue = '🔥 Must Try' | '👍 Good' | '🤔 Maybe' | '⏭️ Skip';
